export default __webpack_public_path__ + "static/media/ic-third-grade.a95f3103.svg";